import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"
import {XXL_BREAKPOINT_MAX} from "../../../../config/constants"

const calculateGridColumns = (
    quickLinkCount,
    enableContentBanner,
    showCountrySelector,
    compensation,
    isMobile = false,
) => {
    if (isMobile) {
        return showCountrySelector ? "90% 10%" : "100%"
    }

    // If quickLinks should show and the content banner is enabled, take space from the content banner
    // for the quickLinks + 10% extra if the country selector is showing
    if (quickLinkCount > 0 && enableContentBanner) {
        return `${100 - compensation - quickLinkCount * 10 - (showCountrySelector ? 10 : 0)}% ${
            quickLinkCount * 10 + compensation + (showCountrySelector ? 10 : 0)
        }%`
    }

    // If there is no quick links but the country select should show
    if (showCountrySelector) {
        return `90% 10%`
    }

    // No quick links and no country selector, leave all the space for the content banner
    return "100%"
}

export const ContentBannerWrapper = styled("div", {
    shouldForwardProp: prop =>
        !["quickLinkCount", "enableContentBanner", "showCountrySelector", "xxlBreakpointEnabled"].includes(prop as any),
})<{quickLinkCount: number; enableContentBanner: boolean; showCountrySelector: boolean; xxlBreakpointEnabled: boolean}>`
    margin-left: auto;
    margin-right: auto;
    max-width: ${({xxlBreakpointEnabled}) => (xxlBreakpointEnabled ? XXL_BREAKPOINT_MAX : breakpoints.values.xl)}px;
    display: grid;
    width: 100%;
    overflow: hidden;

    @media (max-width: ${breakpoints.values.md - 0.25}px) {
        grid-template-columns: ${({quickLinkCount, enableContentBanner, showCountrySelector}) =>
            calculateGridColumns(quickLinkCount, enableContentBanner, showCountrySelector, 2, true)};
    }

    @media (min-width: ${breakpoints.values.md}px) {
        grid-template-columns: ${({quickLinkCount, enableContentBanner, showCountrySelector}) =>
            calculateGridColumns(quickLinkCount, enableContentBanner, showCountrySelector, 10)};
    }

    @media (max-width: ${breakpoints.values.sm}px) {
        width: 100%;
        display: grid;
        justify-content: center;
        padding: 0;
    }
`
